"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let TopbarMap = class TopbarMap extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.animationTriggeredIndex = -1;
    }
    created() {
        console.log(this.area);
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    copyCoord(point, i) {
        const coords = this.collectLonPoint(point);
        const coordsString = coords.lat + ', ' + coords.lon;
        navigator.clipboard.writeText(coordsString);
        this.animationTriggeredIndex = i;
    }
    resetAnimation() {
        this.animationTriggeredIndex = -1;
    }
    collectLonPoint(point) {
        let cadena = point;
        if (cadena.includes('(')) {
            const cadenaTemp = cadena.split('(');
            cadena = cadenaTemp[1];
            if (cadena.includes(')')) {
                const cadenaTemp2 = cadena.split(')');
                cadena = cadenaTemp2[0];
            }
        }
        const values = cadena.split(' ');
        return {
            lat: values[1],
            lon: values[0],
        };
    }
    beautifyExtension(s) {
        if (s && parseInt(s) > 0) {
            return (Math.round((parseFloat(s) + Number.EPSILON) * 100) / 100).toString();
        }
        return '-';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TopbarMap.prototype, "area", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TopbarMap.prototype, "samplingPoints", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'dark' })
], TopbarMap.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], TopbarMap.prototype, "areaSelected", void 0);
TopbarMap = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'TopbarDownloadedMap',
        components: {
            PinIcon: bmk_ui_framework_1.PinIcon,
            GuideIcon: bmk_ui_framework_1.GuideIcon,
            Dropdown: floating_vue_1.Dropdown,
            PairIcon: bmk_ui_framework_1.PairIcon,
            DragDrop: bmk_ui_framework_1.DragDrop,
            Download: lucide_vue_next_1.Download,
            Accordion: bmk_ui_framework_1.Accordion,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            ChevronUp: lucide_vue_next_1.ChevronUp,
            Copy: lucide_vue_next_1.Copy,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            DateStylized: bmk_ui_framework_1.DateStylized,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBody: bmk_ui_framework_1.TableBody,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            Button: bmk_ui_framework_1.Button,
            MicroFeedback: bmk_ui_framework_1.MicroFeedback,
            RateLogo: bmk_ui_framework_1.RateLogo,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            TrackingLogo: bmk_ui_framework_1.TrackingLogo,
        },
    })
], TopbarMap);
exports.default = TopbarMap;
